import { FC, useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

const MIN_TEXTAREA_HEIGHT = 113;

interface ICustomTextAreaProps {
    value: string;
    setValue: (value: string) => void;
    placeholder: string;
}

const CustomTextArea: FC<ICustomTextAreaProps> = ({
    value,
    setValue,
    placeholder,
}) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useLayoutEffect(() => {
        // Reset height - important to shrink on delete
        if (textareaRef.current) {
            if (value !== '') {
                textareaRef.current.style.height = 'inherit';
                // Set height
                textareaRef.current.style.height = `${Math.max(
                    textareaRef.current.scrollHeight,
                    MIN_TEXTAREA_HEIGHT,
                )}px`;
            } else {
                textareaRef.current.style.height = '50px';
            }
        }
    }, [value]);

    return (
        <StyledCustomTextArea>
            <textarea
                title="Комментарий"
                name="comment"
                ref={textareaRef}
                style={{
                    minHeight: MIN_TEXTAREA_HEIGHT,
                }}
                placeholder={placeholder}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
        </StyledCustomTextArea>
    );
};

const StyledCustomTextArea = styled.div`
    textarea {
        display: block;
        width: 100%;
        padding: 15px 20px 10px 20px;
        color: #172945;
        font-size: 15px;
        background-color: #f6f6f6;
        border: 1px solid #f0f0f0;
        line-height: 130%;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-transition: border-color 300ms ease;
        transition: border-color 300ms ease;
        resize: none;
        overflow: hidden;
        &:focus {
            border-color: #172945;
        }
        &::placeholder {
            /* line-height: 0; */
        }
    }
`;

export default CustomTextArea;
